/* Returning-visitor brand affinity. Vendor strings only. No customer PII. */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
  root.bgBrandAffinity = api;
  if (typeof document !== "undefined") {
    var boot = function () { api.boot(document); };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  var VIEW_KEY = "bg_brand_viewed_v1";
  var BOUGHT_KEY = "bg_brand_bought_v1";
  var CAP = 99;

  function norm(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
  }

  function readMap(key) {
    try {
      var parsed = JSON.parse(localStorage.getItem(key) || "{}");
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (err) {
      return {};
    }
  }

  function writeMap(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      /* private mode or full storage: reorder still uses this page's order JSON */
    }
  }

  function bump(key, name, amount) {
    var id = norm(name);
    if (!id) return;
    var map = readMap(key);
    var next = Math.min(CAP, (Number(map[id]) || 0) + (amount || 1));
    map[id] = next;
    writeMap(key, map);
  }

  function rememberOrders(vendors) {
    var map = readMap(BOUGHT_KEY);
    var changed = false;
    (vendors || []).forEach(function (vendor) {
      var id = norm(vendor);
      if (!id || map[id]) return;
      map[id] = 1;
      changed = true;
    });
    if (changed) writeMap(BOUGHT_KEY, map);
  }

  function weights(viewed, bought, orders) {
    var score = {};
    function add(raw, amount) {
      var id = norm(raw);
      if (!id) return;
      score[id] = (score[id] || 0) + amount;
    }
    Object.keys(viewed || {}).forEach(function (id) {
      add(id, Number(viewed[id]) || 0);
    });
    Object.keys(bought || {}).forEach(function (id) {
      add(id, (Number(bought[id]) || 0) * 5);
    });
    (orders || []).forEach(function (vendor) {
      var id = norm(vendor);
      if (!id || score["seen:" + id]) return;
      score["seen:" + id] = 1;
      add(vendor, 5);
    });
    return score;
  }

  function rank(names, viewed, bought, orders) {
    var score = weights(viewed, bought, orders);
    return names
      .map(function (name, index) {
        return { name: name, index: index, score: score[norm(name)] || 0 };
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      })
      .map(function (row) { return row.name; });
  }

  function orderVendors(doc) {
    var nodes = doc.querySelectorAll("[id^='tb-sbb-order-vendors']");
    var vendors = [];
    Array.prototype.forEach.call(nodes, function (node) {
      try {
        var parsed = JSON.parse(node.textContent || "[]");
        if (Array.isArray(parsed)) vendors = vendors.concat(parsed);
      } catch (err) {
        /* skip a malformed block */
      }
    });
    return vendors;
  }

  function reorder(doc, viewed, bought) {
    rememberOrders(orderVendors(doc));
    bought = readMap(BOUGHT_KEY);
    var score = weights(viewed, bought, []);
    var grids = doc.querySelectorAll(".tb-sbb__grid");
    Array.prototype.forEach.call(grids, function (grid) {
      var tiles = Array.prototype.slice.call(grid.children);
      tiles.forEach(function (tile, index) { tile.dataset.bgOrig = String(index); });
      tiles.sort(function (a, b) {
        var sa = score[norm(a.getAttribute("data-brand"))] || 0;
        var sb = score[norm(b.getAttribute("data-brand"))] || 0;
        if (sb !== sa) return sb - sa;
        return Number(a.dataset.bgOrig) - Number(b.dataset.bgOrig);
      });
      tiles.forEach(function (tile) { grid.appendChild(tile); });
    });
  }

  function boot(doc) {
    var viewNode = doc.getElementById("bg-brand-view-vendor");
    if (viewNode && viewNode.textContent) {
      try {
        bump(VIEW_KEY, JSON.parse(viewNode.textContent), 1);
      } catch (err) {
        bump(VIEW_KEY, viewNode.textContent, 1);
      }
    }
    var boughtNode = doc.getElementById("bg-brand-bought-vendors");
    if (boughtNode) {
      try {
        rememberOrders(JSON.parse(boughtNode.textContent || "[]"));
      } catch (err) {
        /* ignore malformed order page payload */
      }
    }
    reorder(doc, readMap(VIEW_KEY), readMap(BOUGHT_KEY));
  }

  return { norm: norm, rank: rank, weights: weights, boot: boot };
});
